<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="9"></ucMenu>
					<div class="right_con">
						<div class="rc_main" v-loading="isLoading">
							<p class="fb">上架策略</p>
							<div class="totals_btn">
								<el-button plain type="primary" size="small" @click="strategryOpen(0)">新增策略</el-button>
								<el-button plain size="small" @click="batchDelStrategry">删除策略</el-button>
							</div>
							<el-table class="rc_table" highlight-current-row @selection-change="selection"  row-key="id" :data="list" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
								<el-table-column align="center" type="selection" width="50"></el-table-column>
								<el-table-column align="center"  property="name" label="策略名称" show-overflow-tooltip width=""></el-table-column>
								<el-table-column align="center"  property="created_at" label="创建时间" show-overflow-tooltip width=""></el-table-column>
								<el-table-column align="center"  property="scope" label="是否默认" show-overflow-tooltip width="">
									<template slot-scope="scope">
										<span style="margin-left:6px">{{scope.row.is_default?'是':'否'}}</span>
									</template>
								</el-table-column>
								<el-table-column label="操作" align="center" width="180">
									<template slot-scope="scope">
										<el-button size="mini" type="primary" @click="strategryOpen(scope.row)" >修改</el-button>
										<el-button size="mini" @click="delStrategry(scope.row)" >删除</el-button>
									</template>
								</el-table-column>
							</el-table>
							<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" v-if="page_data.total>page_data.limit" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
		<!-- 新增/修改策略 -->
		<el-dialog :title="strategy?'编辑':'新增'" :visible.sync="formDialog" width="1200px" @close='closeMask'>
      <div style="max-height: 700px;overflow-y: auto;overflow-x: hidden">
			<el-form label-width="100px" :model="strategy" class="opts_line" v-if="strategy">
				<el-form-item label="策略名称">
					<el-input size="small" v-model="strategy.name" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="标题前缀">
					<el-input size="small" v-model="strategy.title_prefix" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="默认SKU后缀">
					<el-input size="small" v-model="strategy.sku_suffix" placeholder="请输入"></el-input>
					<div style="font-size: 12px; color: red; margin-top: 5px;">不输入则默认商品原SKU名称，设置后会同步设置的SKU后缀</div>
					<div style="font-size: 12px; color: #999; margin-top: 5px;">示例：颜色分类：黑色（SKU后缀）</div>

				</el-form-item>
				<el-form-item label="价格公式" required>
					<div class="con">
						<p class="t">原价格 x</p>
						<el-input class="w80 ml8" v-model="strategy.price_factor" size="small"></el-input>
						<el-select class="w80 ml8" v-model="strategy.price_operator" size="small">
							<el-option v-for="(item,index) in typeOptions" :label="item.label" :value="item.value" :key="index"></el-option>
						</el-select>
						<el-input class="w80 ml8" v-model="strategy.price_offset" size="small"></el-input>
						<p class="t ml8">元</p>
					</div>
				</el-form-item>
				<el-form-item label="运费加到售价">
					<div class="postage-row">
						<el-radio class="postage-radio" v-model="strategy.alibaba_non_free_postage_mode" label="fixed" @change="handleAlibabaNonFreePostageModeChange"></el-radio>
						<el-tooltip effect="dark" placement="top">
							<div slot="content" style="max-width: 560px; font-size: 14px; line-height: 1.6;">
								<div>1、可能存在部分商品识别不到是否包邮，或只针对某些地区包邮的情况，无法保证百分百判定准确，请自行核实后再提交任务。</div>
								<div>2、不包邮的判断，是只要有一个城市不包邮，就判定为不包邮。</div>
							</div>
							<i class="el-icon-question postage-help-icon"></i>
						</el-tooltip>
						<span>若来源商品不包邮，计算后的售卖价 +</span>
						<el-input
							class="postage-input"
							size="small"
							v-model="strategy.alibaba_non_free_postage_amount"
							:disabled="strategy.alibaba_non_free_postage_mode !== 'fixed'"
						></el-input>
						<span>元</span>
					</div>
					<div class="postage-row">
						<el-radio class="postage-radio" v-model="strategy.alibaba_non_free_postage_mode" label="region" @change="handleAlibabaNonFreePostageModeChange"></el-radio>
						<el-tooltip effect="dark" placement="top">
							<div slot="content" style="max-width: 560px; font-size: 14px; line-height: 1.6;">
								按1688商品发往所选省份的首件运费计算；无法识别模板时本商品不加运费，仍会继续铺货。
							</div>
							<i class="el-icon-question postage-help-icon"></i>
						</el-tooltip>
						<span>若来源商品不包邮，计算后的售卖价 +（来源发往</span>
						<el-select class="postage-province" size="small" v-model="strategy.alibaba_region_freight_province_code" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'">
							<el-option v-for="province in provinceOptions" :key="province.value" :label="province.label" :value="province.value"></el-option>
						</el-select>
						<span>的运费 ×</span>
						<el-input class="postage-input" size="small" v-model="strategy.alibaba_region_freight_percent" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'"></el-input>
						<span>% +</span>
						<el-input class="postage-input" size="small" v-model="strategy.alibaba_region_freight_amount" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'"></el-input>
						<span>元）</span>
					</div>
					<div class="postage-row">
						<el-checkbox v-model="strategy.alibaba_free_postage_low_price_enabled"></el-checkbox>
						<el-tooltip effect="dark" placement="top">
							<div slot="content" style="max-width: 560px; font-size: 14px; line-height: 1.6;">
								SKU价格低于{{ strategy.alibaba_free_postage_low_price_threshold }}元指的是：只要其中一个SKU价格低于{{ strategy.alibaba_free_postage_low_price_threshold }}元就算。
							</div>
							<i class="el-icon-question postage-help-icon"></i>
						</el-tooltip>
						<span>若来源商品包邮，且存在SKU价格低于</span>
						<el-input
							class="postage-input"
							size="small"
							v-model="strategy.alibaba_free_postage_low_price_threshold"
							:disabled="!strategy.alibaba_free_postage_low_price_enabled"
						></el-input>
						<span>元，系统统一加</span>
						<el-input
							class="postage-input"
							size="small"
							v-model="strategy.alibaba_free_postage_low_price_amount"
							:disabled="!strategy.alibaba_free_postage_low_price_enabled"
						></el-input>
						<span>元到商品售价</span>
					</div>
				</el-form-item>
				<el-form-item label="分角设置" required>
					<div class="con">
            <el-radio-group v-model="strategy.rounding_mode">
              <el-radio :label="item.value" v-for="(item,index) in fenjiao_options" :key="index">{{item.label}}</el-radio>
            </el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="铺货方式" required>
					<div class="con">
            <el-radio-group v-model="strategy.listing_mode">
              <el-radio :label="item.value" v-for="item in puhuo_options" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
					</div>
					<div style="font-size: 12px; color: #999; margin-top: 5px;">备注：微信小店不支持选择上架到仓库，选择上架仓库会发布到草稿箱</div>
				</el-form-item>
<!--				<el-form-item label="铺货优化">
					<div class="con">
						<el-checkbox v-model="strategy.is_three_pic" :true-label="1" :false-label="0">3:4图优化</el-checkbox>
					</div>
				</el-form-item>-->
				<el-form-item label="商品SKU设置">
					<div class="totals_btn" style="margin-top: 0;">
						<el-button plain type="primary" size="small" @click="addSpecType" :disabled="strategy.spec_types && strategy.spec_types.length >= 5">新增商品规格类型+</el-button>
					</div>
					<div style="font-size: 12px; color: red; margin-top: 5px; margin-bottom: 10px;">商品SKU名称、价格可自定义设置、最多支持5个规格类型</div>
					<div v-for="(item, index) in strategy.spec_types" :key="index" style="margin-top: 10px; display: flex; align-items: center;">
						<div class="sku-item">
							<div class="sku-title">商品SKU{{index+1}}</div>
							<div class="sku-content">
								<div class="sku-row">
									<span class="sku-label" ><span style="color: red;">*</span>SKU后缀</span>
									<el-input size="small" v-model="item.sku_suffix" placeholder="请输入"></el-input>
								</div>
								<div class="sku-row">
									<span class="sku-label" ><span style="color: red;">*</span>价格公式</span>
									<span style="margin-right: 8px;">原价格 x</span>
									<el-input class="w80" style="width: 80px; margin-right: 8px;" v-model="item.price_factor" size="small"></el-input>
									<el-select class="w80" style="width: 80px; margin-right: 8px;" v-model.number="item.price_operator" size="small">
										<el-option v-for="option in typeOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
									</el-select>
									<el-input class="w80" style="width: 80px; margin-right: 8px;" v-model="item.price_offset" size="small"></el-input>
									<span style="margin-right: 8px;">元</span>
								</div>
								<div class="sku-row">
									<span class="sku-label"><span style="color: red;">*</span>角分设置</span>
                  <el-radio-group v-model="item.rounding_mode">
                    <el-radio :label="item.value" v-for="item in fenjiao_options" :key="item.value">{{item.label}}</el-radio>
                  </el-radio-group>

								</div>
							</div>
						</div>
						<el-button plain size="mini" type="danger" @click.stop="removeSpecType(index)" style="margin-left: 10px;">删除</el-button>
					</div>
				</el-form-item>
				<el-form-item label="是否默认">
					<el-switch v-model="strategy.is_default"  active-color="#13ce66"></el-switch>
				</el-form-item>
			</el-form>
      </div>
        <div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeMask'>取消</el-button>
				<el-button size="small" type="primary" class="title" @click="saveEdit()">保存</el-button>

			</div>
		</el-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import common from '../../assets/js/utils/common.js';
import areaData from '../../assets/js/data/area.js';

const MAINLAND_PROVINCE_CODES = ['110000', '120000', '130000', '140000', '150000', '210000', '220000', '230000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '410000', '420000', '430000', '440000', '450000', '460000', '500000', '510000', '520000', '530000', '540000', '610000', '620000', '630000', '640000', '650000', '710000', '810000', '820000'];
export default {
	name: "ucenterEmployeeManage",
	components:{
		myHead,myFoot,ucMenu,Pagination
	},
	data() {
		return {
			isLoading: false,
			searchData:{},
			page_data: {
				limit: 100,
				page: 1,
				total:0,
			},

			formDialog: false,
			strategy: null,
			init_strategy: {
        id: null,
        name: '',
        price_factor: 1.00,
        price_operator: '+',
        price_offset: 5.00,
        alibaba_non_free_postage_enabled: true,
        alibaba_non_free_postage_amount: 5.00,
        alibaba_region_freight_enabled: false,
        alibaba_region_freight_province_code: '310000',
        alibaba_region_freight_percent: 100.00,
        alibaba_region_freight_amount: 0.00,
        alibaba_non_free_postage_mode: 'fixed',
        alibaba_free_postage_low_price_enabled: false,
        alibaba_free_postage_low_price_threshold: 5.00,
        alibaba_free_postage_low_price_amount: 3.00,
        rounding_mode: 0,
        listing_mode: 2,
        shippingTime: '48h',
        is_default: false,
        sku_suffix: '',
        spec_types: [],
        title_prefix:'',
      },
			list:[],
			roleList:[],
			ids:[],
			typeOptions: [
				{ label: '+', value: '+' },
				{ label: '-', value: '-' }
			],
			fenjiao_options: [
				{ label: '保留分角', value: 0 },
				{ label: '抹去分', value: 1 },
				{ label: '抹去角', value: 2 }
			],
			puhuo_options: [
				{ label: '上架', value: 0 },
				{ label: '放入仓库', value: 1 },
				{ label: '放入草稿箱', value: 2 }
			],
			provinceOptions: MAINLAND_PROVINCE_CODES.map(value => ({ value, label: areaData.province_list[value] }))
		}
	},
	created() {
		this.getList()
	},
	methods: {
		...mapActions({
			getCelveData: "ucenter/getCelveData",
			saveCelveData: "ucenter/saveCelveData",
			opDelCelve: "ucenter/opDelCelve",
		}),
		strategryOpen(row){//打开策略弹窗
			if(row){
        this.strategy = {...this.init_strategy, ...row}
				this.strategy.alibaba_non_free_postage_mode = this.strategy.alibaba_region_freight_enabled ? 'region' : (this.strategy.alibaba_non_free_postage_enabled ? 'fixed' : '')
        this.strategy.spec_types = this.strategy.spec_types?JSON.parse( this.strategy.spec_types):[]
			}else{
				this.strategy = {...this.init_strategy}
				// this.$set(this.strategy, 'is_three_pic', 0)
				// this.$set(this.strategy, 'is_white_image', 0)
			}
			this.formDialog = true
		},
    batchDelStrategry(){
      if(!this.ids.length){
        this.$message.warning('请选择要删除的策略')
        return false
      }
      this.delStrategry()
    },
    //删除策略
		delStrategry(row){//策略删除
			this.$confirm('确定操作吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let ids = row&&row.id ? [row.id] : this.ids
				this.opDelCelve({data:{ids:ids},success:(res)=>{
					if(res.code==200){
						this.$message({type: 'success',message: res.message})
						this.getList()
					} else {
						this.$message({message: res.message,type: 'error',});
					}
					this.isLoading = false
				}})
			}).catch(() => {})
		},
	  //获取策略列表
		getList(showLoading = true){//获取策略列表
			if(showLoading) this.isLoading = true
			let param = {page_size:this.page_data.limit,page:this.page_data.page}
			Object.assign(param, this.searchData)
			this.getCelveData({data:param,success:(res)=>{
				if(res.code==200){
					// let data = res.data
					// for(let i in data){
					// 	data[i].date = common._date(data[i].createtime,'Y-m-d H:i:s')
					// }
					this.list = res.data.list
          this.page_data.total = res.data.total
          // this.init_strategy = res.data.init_strategy
          // this.strategy = res.data.init_strategy
				} else {
					this.$message({message: res.message,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		closeMask(){//关闭弹窗
			this.strategy = this.init_strategy
			this.formDialog = false
		},
    //新增、编辑策略
		saveEdit(){
			if(!this.strategy.name){
				this.$message({type: 'info',message: "请输入策略名称！"})
				return false
			}
			if(this.strategy.coefficient<1){
				this.$message({type: 'info',message: "系数不能小于1！"})
				return false
			}
			const moneyPattern = /^\d+(\.\d{1,2})?$/
			this.handleAlibabaNonFreePostageModeChange(this.strategy.alibaba_non_free_postage_mode)
			if(this.strategy.alibaba_non_free_postage_enabled && !moneyPattern.test(String(this.strategy.alibaba_non_free_postage_amount))) {
				this.$message({type: 'info', message: '1688不包邮加价金额必须大于0且最多保留两位小数！'})
				return false
			}
			if(this.strategy.alibaba_non_free_postage_enabled && Number(this.strategy.alibaba_non_free_postage_amount) <= 0) {
				this.$message({type: 'info', message: '1688不包邮加价金额必须大于0！'})
				return false
			}
			if(this.strategy.alibaba_region_freight_enabled) {
				if(!this.provinceOptions.some(item => item.value === this.strategy.alibaba_region_freight_province_code)) {
					this.$message({type: 'info', message: '请选择有效的发往省份！'})
					return false
				}
				if(!moneyPattern.test(String(this.strategy.alibaba_region_freight_percent)) || Number(this.strategy.alibaba_region_freight_percent) < 0 || Number(this.strategy.alibaba_region_freight_percent) > 1000) {
					this.$message({type: 'info', message: '指定地区运费比例必须为0到1000且最多保留两位小数！'})
					return false
				}
				if(!moneyPattern.test(String(this.strategy.alibaba_region_freight_amount)) || Number(this.strategy.alibaba_region_freight_amount) < 0) {
					this.$message({type: 'info', message: '指定地区固定加价必须大于等于0且最多保留两位小数！'})
					return false
				}
			}
			if(this.strategy.alibaba_free_postage_low_price_enabled) {
				if(!moneyPattern.test(String(this.strategy.alibaba_free_postage_low_price_threshold)) || Number(this.strategy.alibaba_free_postage_low_price_threshold) <= 0) {
					this.$message({type: 'info', message: '1688包邮低价SKU阈值必须大于0且最多保留两位小数！'})
					return false
				}
				if(!moneyPattern.test(String(this.strategy.alibaba_free_postage_low_price_amount)) || Number(this.strategy.alibaba_free_postage_low_price_amount) <= 0) {
					this.$message({type: 'info', message: '1688包邮低价SKU加价金额必须大于0且最多保留两位小数！'})
					return false
				}
			}

			// 验证规格类型
			// if(this.strategy.spec_types && this.strategy.spec_types.length > 0) {
			// 	for(let i = 0; i < this.strategy.spec_types.length; i++) {
			// 		const item = this.strategy.spec_types[i]
			// 		// SKU后缀是必填的
			// 		if(!item.sku_suffix) {
			// 			this.$message({type: 'info',message: `商品SKU${i+1}的SKU后缀不能为空！`})
			// 			return false
			// 		}
			// 		if(!item.price_factor || item.price_factor < 1) {
			// 			this.$message({type: 'info',message: `商品SKU${i+1}的价格系数不能小于1！`})
			// 			return false
			// 		}
			// 		if(item.price_offset === undefined || item.price_offset === '') {
			// 			this.$message({type: 'info',message: `商品SKU${i+1}的价格金额不能为空！`})
			// 			return false
			// 		}
			// 	}
			// }

			let params = {...this.strategy}
      params.spec_types = JSON.stringify(params.spec_types)
			this.saveCelveData({data:params,success:(res)=>{
				if (res.code === 200) {
					// console.log('save celve',res)
					this.$message.success(res.message);
					this.formDialog = false
					this.getList()
				} else {
					this.$message.error(res.message);
				}
				this.isLoading = false

			}})
		},

		selection(selection) {
			this.ids = selection.map(item => item.id)
		},
    //新增sku
		addSpecType() {
			if(this.strategy.spec_types==null){
				this.strategy.spec_types = []
			}
			if(this.strategy.spec_types.length >= 5) {
				this.$message({
					type: 'warning',
					message: '最多只能添加5个商品规格类型'
				});
				return;
			}
			this.strategy.spec_types.push({
        sku_suffix: '',
        price_factor: 1.00,
        price_operator: '+',
        price_offset: 0,
        rounding_mode: 0,
			});
		},
    //删除sku
		removeSpecType(index) {
			// 使用Vue.delete方法删除数组中的元素
			this.$delete(this.strategy.spec_types, index);
		},
		getTypeLabel(type) {
			const option = this.typeOptions.find(opt => opt.value === parseInt(type));
			return option ? option.label : type;
		},
		handleAlibabaNonFreePostageModeChange(mode) {
			this.strategy.alibaba_non_free_postage_enabled = mode === 'fixed'
			this.strategy.alibaba_region_freight_enabled = mode === 'region'
		},
		handleRadioFocus(e) {
			// 防止radio获得焦点时的aria-hidden警告
			if (e.target && e.target.getAttribute('aria-hidden') === 'true') {
				e.target.blur();
				e.target.parentElement.focus();
			}
		},
		handleRadioBlur() {
			// 清除可能的残留焦点
			const activeElement = document.activeElement;
			if (activeElement && activeElement.classList.contains('el-radio__input')) {
				activeElement.blur();
			}
		},
	}
}

</script>

<style scoped>

.center{display: flex;flex: 1;}
.ucenter_main{min-height: 500px;}

.rc_table{width: 100%;margin-top: 20px}
.rc_main{padding: 36px 40px 46px;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 15px;}
.select_wrap .w290{width: 290px;margin-top: 14px;margin-right: 15px;position: relative;}
.select_wrap .w290:nth-child(3n){margin-right: 0;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.tree_checkall{margin-top: 12px;}
.tree_box{padding: 10px;width: 100%;border: 1px solid #DCDFE6;border-radius: 4px;box-sizing: border-box;max-height: 250px;overflow: hidden auto;margin-top: 12px;}
.tree_box::-webkit-scrollbar{width:4px;}
.tree_box::-webkit-scrollbar-thumb{background: #DDDDDD;border-radius: 4px;}
.tree_box::-webkit-scrollbar-track{background: #F2F2F2;border-radius: 4px;}
.w100{width: 100%;}


.opts_line .txt {
		width: 120px;
		text-align: right;
		font-size: 14px;

	}

	.opts_line .con {
		width: 90%;
		display: flex;
		align-items: center;
		height: 40px;
	}

	.opts_line .con .t {
		font-size: 14px;
		white-space: nowrap;
		margin:0 10px;
	}

	.postage-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		min-height: 40px;
	}

	.postage-row span {
		white-space: nowrap;
	}

	.postage-input {
		width: 90px;
	}

	.postage-province {
		width: 130px;
	}

	.postage-help-icon {
		color: #909399;
		cursor: pointer;
		font-size: 16px;
	}

</style>
<style>
.postage-radio {
	margin-right: 0;
}

.postage-radio .el-radio__label {
	display: none;
}
</style>
<style scoped>

.select_wrap .el-button{margin-top: 14px;}
.select_wrap .el-input--prefix .el-input__inner,.select_wrap .el-cascader .el-input .el-input__inner{padding-left: 76px !important;height: 34px;line-height: 34px;font-size: 12px !important;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.select_wrap .el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}

.el-button--small{padding: 7px 15px;}

.totals_btn .el-button--primary.is-plain{border-color: #fff;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-input.is-focus .el-input__inner,.el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}
.rc_table.el-table th.el-table__cell>.cell{padding: 0 14px;}

.sku-item {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 10px;
	width: 100%;
}
.sku-title {
	font-weight: bold;
	margin-bottom: 10px;
	font-size: 14px;
}
.sku-content {
	padding-left: 10px;
}
.sku-row {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.sku-label {
	width: 80px;
	text-align: right;
	margin-right: 10px;
	font-size: 14px;
}
.custom-radio-group {
	display: inline-flex;
	align-items: center;
	gap: 20px;
}

.custom-radio {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
}

.custom-radio__inner {
	position: relative;
	display: inline-block;
	width: 14px;
	height: 14px;
	border: 1px solid #DCDFE6;
	border-radius: 50%;
	margin-right: 8px;
}

.custom-radio__inner::after {
	content: "";
	position: absolute;
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: #fff;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: none;
}

.custom-radio.is-active .custom-radio__inner {
	border-color: var(--red);
	background: var(--red);
}

.custom-radio.is-active .custom-radio__inner::after {
	display: block;
}

.custom-radio:hover .custom-radio__inner {
	border-color: var(--red);
}

.custom-radio__label {
	font-size: 14px;
	color: #606266;
}

.custom-radio.is-active .custom-radio__label {
	color: var(--red);
}
</style>
